import { render, staticRenderFns } from "./IssuesNewCustomerDependent.vue?vue&type=template&id=e2441866&"
import script from "./IssuesNewCustomerDependent.vue?vue&type=script&lang=js&"
export * from "./IssuesNewCustomerDependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports